{
  "EMOJI": {
    "PLACEHOLDER": "Buscar emojis",
    "NOT_FOUND": "Ningún emoji coincide con tu búsqueda",
    "REMOVE": "Eliminar"
  }
}
